function toggle(e) {
    e.preventDefault();

    $('#contact-modal').toggleClass('open');
}

$(document).ready(() => {
    $('*[data-modal-toggle]').click(toggle);
});



// WEBPACK FOOTER //
// ./src/js/modal.js